"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumCurrencyCode = void 0;
var EnumCurrencyCode;
(function (EnumCurrencyCode) {
    EnumCurrencyCode["PEN"] = "PEN";
    EnumCurrencyCode["USD"] = "USD";
})(EnumCurrencyCode = exports.EnumCurrencyCode || (exports.EnumCurrencyCode = {}));
;
